import { Channel } from 'src/app/models/channel';
import { IRepository } from 'src/app/repositories/interface.repository';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { BaseRepository, OrderBy } from 'src/app/repositories/base.repository';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { Injectable } from '@angular/core';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { ChannelItem } from '../models/channel_item';

export enum ChannelSortBy {
    Title,
    PublishDate
}

@Injectable()
export class ChannelRepository extends BaseRepository implements IRepository {

    constructor(public http: HttpClient, public functionsService: FunctionsService, public clientConfig: ClientConfigService, private _xmlParser: NgxXml2jsonService) {
        super(http, functionsService, clientConfig, 'Channel');
    }

    async getAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async getAllAsync(headers: HttpHeaders, pageIndex: number, pageSize: number, sortBy: ChannelSortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async addAsync(headers: HttpHeaders, addChannels: Channel[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Add', JSON.stringify(addChannels), {headers}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });
        return responseMsg;
    }

    async updateAsync(headers: HttpHeaders, updateChannel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Update', updateChannel, {headers}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async removeAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        return responseMsg;
    }

    async parseChannelOnServerAsync(headers: HttpHeaders, channel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        const params = new HttpParams().set('channelId', '0')
                                       .set('rssUrl', channel.ChannelUrl);

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'ParseRss', { headers, params}).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async parseChannelOnClientAsync(channel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        const params = new HttpParams().set('url', channel.ChannelUrl);

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'GetWebPageContent', { params }).toPromise().then(resp => {
            responseMsg = resp;

            if (responseMsg.Status === CoreResponseStatus.NoData) {
                let xml: string = responseMsg.Message;

                responseMsg.Status = CoreResponseStatus.OK;
                responseMsg.Result = this.parseRssXml(xml);
            }
        }).catch(err => {
            responseMsg = err.error;
        })

        return responseMsg;
    }

    private parseRssXml(xml: string): ChannelItem[] {
        let channelItems: ChannelItem[];

        // parse rss xml to create channel item array
        
        return channelItems;
    }
}